var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMail = function SvgMail(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 20 21"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M3.334 3a2.505 2.505 0 0 0-2.5 2.5v10c0 1.377 1.123 2.5 2.5 2.5h13.333c1.377 0 2.5-1.123 2.5-2.5v-10c0-1.377-1.123-2.5-2.5-2.5zm-.745 2.128a.84.84 0 0 1 .744-.461h13.334c.323 0 .606.189.744.461l-7.41 5.188zM2.5 7.101V15.5c0 .456.377.833.833.833h13.334a.84.84 0 0 0 .833-.833V7.1l-7.022 4.916c-.287.2-.669.2-.956 0z",
    clipRule: "evenodd"
  })));
};
export default SvgMail;